var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4758_92872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3387 16.8983C15.8106 16.7593 15.3389 16.4597 14.9885 16.0409C14.6382 15.6221 14.4266 15.1048 14.3831 14.5606C13.9658 14.4216 13.5287 14.3513 13.0889 14.3526C12.0044 14.3526 10.9644 14.7833 10.1976 15.5502C9.43079 16.317 9 17.357 9 18.4414V19.1828C10.1087 19.9885 11.4314 20.4475 12.8009 20.5019C12.9276 19.6018 13.3396 18.7661 13.9763 18.1175C14.6131 17.4689 15.4411 17.0416 16.3387 16.8983Z",
    fill: "#373D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4874 11.3526C15.489 10.8037 15.3028 10.2708 14.9597 9.84234C14.6166 9.41386 14.1373 9.11563 13.6013 8.99714C13.0653 8.87865 12.505 8.94705 12.0132 9.19096C11.5215 9.43488 11.128 9.83965 10.898 10.3381C10.6681 10.8365 10.6155 11.3986 10.749 11.931C10.8826 12.4634 11.1942 12.9341 11.6322 13.265C12.0701 13.5959 12.6081 13.767 13.1568 13.7499C13.7054 13.7329 14.2317 13.5287 14.6483 13.1713C14.7976 12.8761 15.0008 12.6114 15.2474 12.3909C15.4044 12.0672 15.4864 11.7123 15.4874 11.3526Z",
    fill: "#373D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9113 14.3525C20.4744 14.3519 20.0403 14.4222 19.626 14.5605C19.5819 15.1046 19.3702 15.6217 19.0199 16.0404C18.6697 16.4591 18.1982 16.7588 17.6704 16.8983C18.5658 17.0442 19.3911 17.4726 20.0257 18.1209C20.6603 18.7693 21.0709 19.6035 21.1975 20.5019C22.568 20.4468 23.8914 19.9865 25.0002 19.1792V18.4414C25.0002 17.357 24.5694 16.317 23.8026 15.5502C23.0358 14.7833 21.9957 14.3525 20.9113 14.3525Z",
    fill: "#373D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9114 13.7505C21.4331 13.7516 21.941 13.583 22.3584 13.2701C22.7758 12.9571 23.08 12.5169 23.2252 12.0159C23.3704 11.5148 23.3486 10.9801 23.1632 10.4925C22.9778 10.0049 22.6387 9.5909 22.1973 9.31295C21.7558 9.035 21.2359 8.90822 20.7161 8.95174C20.1962 8.99527 19.7046 9.20675 19.3156 9.55424C18.9265 9.90173 18.661 10.3664 18.5592 10.878C18.4575 11.3897 18.5249 11.9205 18.7514 12.3905C18.9989 12.6113 19.2027 12.8766 19.3523 13.1727C19.7861 13.5457 20.3393 13.7507 20.9114 13.7505Z",
    fill: "#373D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0126 17.2031H16.9859C15.9588 17.2088 14.9755 17.6203 14.2505 18.3479C13.5255 19.0756 13.1176 20.0604 13.1157 21.0876V21.7987C14.2452 22.618 15.6048 23.0593 17.0002 23.0593C18.3955 23.0593 19.7552 22.618 20.8846 21.7987V21.0876C20.8827 20.0601 20.4746 19.075 19.7492 18.3473C19.0238 17.6196 18.0401 17.2083 17.0126 17.2031Z",
    fill: "#373D3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7455 16.6171C16.8293 16.6263 16.9136 16.631 16.9979 16.6313C17.0829 16.6313 17.1678 16.626 17.2521 16.6153C17.7476 16.5595 18.211 16.3427 18.5714 15.9981C18.9317 15.6535 19.169 15.2002 19.2468 14.7077C19.2659 14.5902 19.276 14.4713 19.277 14.3522C19.2605 13.759 19.0132 13.1956 18.5877 12.7819C18.1623 12.3682 17.5922 12.1367 16.9988 12.1367C16.4054 12.1367 15.8353 12.3682 15.4099 12.7819C14.9844 13.1956 14.7372 13.759 14.7206 14.3522C14.7207 14.4713 14.7308 14.5903 14.7508 14.7077C14.8283 15.2005 15.0654 15.6542 15.4258 15.9992C15.7861 16.3441 16.2498 16.5612 16.7455 16.6171Z",
    fill: "#373D3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4758_92872",
    x: -1.57143,
    y: -2.57143,
    width: 37.1429,
    height: 37.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.28571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.152941 0 0 0 0 0.168627 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4758_92872"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4758_92872",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.3215916c53450bc5ca7d42301744c436.svg";
export { ForwardRef as ReactComponent };